import EventRatings from './EventRatings'

export default EventRatings
